import { Attr, BelongsTo, Model } from "spraypaint";

import { type AIVisibilityProjectSource } from "shared/modules/AIVisibility/types";
import { ApplicationRecord } from "shared/services/spraypaint";

import type AIVisibilityProject from "./AIVisibilityProject";

@Model()
class AIVisibilityEntity extends ApplicationRecord {
  // No endpoint: entities are fetched through the project's nested
  // /v1/ai/visibility_projects/:id/entities route, and this model only builds
  // query params and deserialises the response. jsonapiType still has to match
  // what the API returns.
  static apiNamespace = "/ai";

  static jsonapiType = "ai_visibility_entities";

  @BelongsTo() aiVisibilityProject: AIVisibilityProject;

  @Attr() aiVisibilityProjectId: number;

  @Attr() avgEntityRank: number;

  @Attr() coverage: number;

  @Attr() entityCount: number;

  @Attr() entityShareOfMentions: number;

  @Attr() entityType: "products" | "brands";

  @Attr() llmResponseCount: number;

  @Attr() location: string;

  @Attr() name: string;

  @Attr() selected: boolean;

  @Attr() source: "all" | AIVisibilityProjectSource;

  @Attr() sourceCount: number;

  @Attr({ persist: false }) updatedAt: string;
}

export default AIVisibilityEntity;
